import * as React from 'react';
import { History } from 'history';
import { Link } from 'react-router-dom';
import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js';
import { handleInputChangeWrapper } from '../../helpers/state';
import { IAccount } from '../../services/account';
import { SITE_URL, TERMS_PATH, LOGIN_PATH } from '../../constants';
import states from '../../data/states.js';

import './styles.css';
import { FormattedMessage, FormattedHTMLMessage, InjectedIntlProps, injectIntl, defineMessages } from 'react-intl';
import { searchLogins } from 'src/services/search';

type IFormat = (value: string | null) => string | null;
interface IInput {
    value: null | string;
    isValid: () => boolean;
    format: undefined | IFormat;
}
interface IState {
    triedEmails: string[];
    hasBeenSubmitted: boolean;
    fields: {
        name: IInput;
        // organization: IInput;
        addressLine1: IInput;
        addressLine2: IInput;
        city: IInput;
        zip: IInput;
        state: IInput;
        phoneWork: IInput;
        phoneMobile: IInput;
        email: IInput;
        password: IInput;
        passwordConfirmed: IInput;
        termsAccepted: {
            value: null | boolean;
            isValid: () => boolean;
            format: undefined | IFormat;
        };
    };
}

interface IProps { history: History, createAccount: (account: IAccount, accountState: IState | null) => void, state?: IState | null }

class CreateAccount extends React.Component<IProps & InjectedIntlProps, IState> {
    messages = defineMessages({
        fullName: {
            id: 'signup.owner.name.placeholder',
            defaultMessage: 'Full Name'
        },
        // org: {
        //     id: 'signup.owner.org.placerholder',
        //     defaultMessage: 'Organization'
        // },
        addrLine1: {
            id: 'signup.owner.addr.line1.placeholder',
            defaultMessage: 'Line One'
        },
        addrLine2: {
            id: 'signup.owner.addr.line2.placeholder',
            defaultMessage: 'Line Two'
        },
        city: {
            id: 'signup.owner.addr.city.placeholder',
            defaultMessage: 'City'
        },
        state: {
            id: 'signup.owner.addr.state.placeholder',
            defaultMessage: 'State'
        },
        zip: {
            id: 'signup.owner.addr.zip.placeholder',
            defaultMessage: 'Zip Code'
        },
        accountAlreadyExists: {
            id: 'signup.owner.email.exists',
            defaultMessage: 'This email is already associated with an account, please use password recovery if you have forgotten your password.'
        },
        phoneFormat: {
            id: 'signup.owner.phone.placeholder',
            defaultMessage: '(###) ###-####'
        }
    });

    state: IState = {
        triedEmails: [],
        hasBeenSubmitted: false,
        fields: {
            name: {
                value: null,
                isValid: () => {
                    if (this.state.hasBeenSubmitted) {
                        return !!this.state.fields.name.value;
                    }
                    return this.state.fields.name.value !== '';
                },
                format: undefined,
            },
            // organization: {
            //     value: null,
            //     isValid: () => {
            //         if (this.state.hasBeenSubmitted) {
            //             return !!this.state.fields.organization.value;
            //         }
            //         return this.state.fields.organization.value !== '';
            //     },
            //     format: undefined,
            // },
            addressLine1: {
                value: null,
                isValid: () => {
                    if (this.state.hasBeenSubmitted) {
                        return !!this.state.fields.addressLine1.value;
                    }
                    return this.state.fields.addressLine1.value !== '';
                },
                format: undefined,
            },
            addressLine2: {
                value: null,
                isValid: () => {
                    return true;
                },
                format: undefined,
            },
            city: {
                value: null,
                isValid: () => {
                    if (this.state.hasBeenSubmitted) {
                        return !!this.state.fields.city.value;
                    }
                    return this.state.fields.city.value !== '';
                },
                format: undefined,
            },
            zip: {
                value: null,
                isValid: () => {
                    if (this.state.hasBeenSubmitted) {
                        return !!this.state.fields.zip.value;
                    }
                    return this.state.fields.zip.value !== '';
                },
                format: undefined,
            },
            state: {
                value: null,
                isValid: () => {
                    if (this.state.hasBeenSubmitted) {
                        return !!this.state.fields.state.value;
                    }
                    return this.state.fields.state.value !== '';
                },
                format: undefined,
            },
            phoneWork: {
                value: null,
                isValid: () => {
                    if (this.state.hasBeenSubmitted) {
                        if (
                            !this.state.fields.phoneWork.value &&
                            !this.state.fields.phoneMobile.value
                        )
                            return false;

                        const workPhoneNumber = parsePhoneNumberFromString(
                            this.state.fields.phoneWork.value || '',
                            'US'
                        );
                        const mobilePhoneNumber = parsePhoneNumberFromString(
                            this.state.fields.phoneMobile.value || '',
                            'US'
                        );
                        if (
                            !!this.state.fields.phoneWork.value &&
                            workPhoneNumber &&
                            !workPhoneNumber.isValid()
                        )
                            return false;
                        if (
                            !this.state.fields.phoneWork.value &&
                            mobilePhoneNumber &&
                            mobilePhoneNumber.isValid()
                        )
                            return true;
                        if (
                            !this.state.fields.phoneMobile.value &&
                            workPhoneNumber &&
                            workPhoneNumber.isValid()
                        )
                            return true;
                    }
                    return (
                        this.state.fields.phoneWork.value !== '' ||
                        this.state.fields.phoneMobile.value !== ''
                    );
                },
                format: (value: string | null) => new AsYouType('US').input(value || ''),
            },
            phoneMobile: {
                value: null,
                isValid: () => {
                    if (this.state.hasBeenSubmitted) {
                        if (
                            !this.state.fields.phoneWork.value &&
                            !this.state.fields.phoneMobile.value
                        )
                            return false;

                        const workPhoneNumber = parsePhoneNumberFromString(
                            this.state.fields.phoneWork.value || '',
                            'US'
                        );
                        const mobilePhoneNumber = parsePhoneNumberFromString(
                            this.state.fields.phoneMobile.value || '',
                            'US'
                        );
                        if (
                            !!this.state.fields.phoneMobile.value &&
                            mobilePhoneNumber &&
                            !mobilePhoneNumber.isValid()
                        )
                            return false;
                        if (
                            !this.state.fields.phoneWork.value &&
                            mobilePhoneNumber &&
                            mobilePhoneNumber.isValid()
                        )
                            return true;
                        if (
                            !this.state.fields.phoneMobile.value &&
                            workPhoneNumber &&
                            workPhoneNumber.isValid()
                        )
                            return true;
                    }

                    return (
                        this.state.fields.phoneWork.value !== '' ||
                        this.state.fields.phoneMobile.value !== ''
                    );
                },
                format: (value: string | null) => new AsYouType('US').input(value || ''),
            },
            email: {
                value: null,
                isValid: () => {
                    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return this.state.triedEmails.includes(this.state.fields.email.value || '') === false && ((!this.state.hasBeenSubmitted && this.state.fields.email.value === null) || re.test(String(this.state.fields.email.value).toLowerCase()));
                },
                format: undefined,
            },
            password: {
                value: null,
                isValid: () => {
                    return (!this.state.hasBeenSubmitted && this.state.fields.password.value === null) || (this.state.fields.password.value || '').length > 7;
                },
                format: undefined,
            },
            passwordConfirmed: {
                value: null,
                isValid: () => {
                    return (
                        this.state.fields.passwordConfirmed.value ===
                        this.state.fields.password.value ||
                        this.state.fields.passwordConfirmed.value === null
                    );
                },
                format: undefined,
            },
            termsAccepted: {
                value: null,
                isValid: () => {
                    return (!this.state.hasBeenSubmitted && this.state.fields.termsAccepted.value === null) || this.state.fields.termsAccepted.value === true;
                },
                format: undefined,
            },
        },
    };

    handleInputChange = handleInputChangeWrapper(this);

    handleSave = () => {
        this.setState({ hasBeenSubmitted: true }, async () => {
            let isValid = true;
            Object.keys(this.state.fields).forEach((item: string) => {
                if (this.state.fields[item].isValid) {
                    if (!this.state.fields[item].isValid()) {
                        isValid = false;
                    }
                }
            });
            if (isValid) {
                const accountSearch = await searchLogins(this.state.fields.email.value || '')
                if (accountSearch.success && Array.isArray(accountSearch.data.rows) && accountSearch.data.rows.length) {
                    this.setState({ triedEmails: [...this.state.triedEmails, this.state.fields.email.value || ''] })
                    alert(this.props.intl.formatMessage(this.messages.accountAlreadyExists));
                    return;
                }
                const account = {
                    address: {
                        firstLine: this.state.fields.addressLine1.value || '',
                        secondLine: this.state.fields.addressLine2.value || '',
                        state: this.state.fields.state.value || '',
                        city: this.state.fields.city.value || '',
                        zipCode: this.state.fields.zip.value || '',
                    },
                    email: this.state.fields.email.value || '',
                    fullName: this.state.fields.name.value || '',
                    // organization: this.state.fields.organization.value || '',
                    organization: '',
                    password: this.state.fields.password.value || '',
                    phone: {
                        work: this.state.fields.phoneWork.value || '',
                        mobile: this.state.fields.phoneMobile.value || '',
                    },
                };
                this.props.createAccount(account, this.state);
                this.props.history.push('/client/signup/organization')
            }
        });
    };

    componentDidMount() {
        if (this.props.state) {
            const fields = { ...this.state.fields };
            Object.keys(fields).forEach(key => {
                fields[key] = {
                    ...fields[key],
                    value: this.props.state && this.props.state.fields && this.props.state.fields[key] ? this.props.state.fields[key].value : null
                }
            })
            this.setState({ fields });
        }
    }

    render() {
        return (
            <section className="px-5 signup">
                <div className="container">

                    <div className="row mt-5">
                        <div className="page-title">
                            <h2><FormattedMessage id="hdr.signup" defaultMessage="Create an Account" /></h2>
                            <FormattedHTMLMessage id="txt.signup"
                                defaultMessage={
                                    `<p>Welcome to Harmonize®! We are pleased to be working with you.</p>

<p>You can create a Harmonize® account in two easy steps:</p>
<ol>
<li>Enter the Account Owner information</li>
<li>Enter your Organization's information</li>
</ol>
<p>Please create only one account per organization. </p>
<br/>
`
                                } />
                        </div>
                    </div>
                    <div className="row">
                        <h3 className="harmonize"><FormattedMessage id="signup.owner.hdr" defaultMessage="Step 1: Account Owner Information" /></h3>
                    </div>
                    <div className="row">
                        <p className="text-muted"><FormattedHTMLMessage id="signup.owner.txt" defaultMessage="Please fill in the following information for the <em>owner</em> of this account." /></p>
                    </div>
                    <div className="row">
                        <div className="col-md">
                            <div className="form-row">
                                <div className="col-sm-6">
                                    <label className="text-muted" htmlFor="name"><FormattedMessage id="signup.owner.name.label" defaultMessage="Full Name" /></label>
                                    <input
                                        value={this.state.fields.name.value || ''}
                                        className={`form-control ${
                                            this.state.fields.name.isValid() === false
                                                ? 'is-invalid'
                                                : ''
                                            }`}
                                        name="name"
                                        onChange={this.handleInputChange}
                                        type="text"
                                        placeholder={this.props.intl.formatMessage(this.messages.fullName)}
                                        required
                                    />
                                    <div className="invalid-feedback">
                                        <FormattedMessage id="signup.owner.name.req" defaultMessage="Your name is required." />
                                    </div>
                                </div>
                                {/* <div className="col-md col-sm-12">
                                <label className="text-muted" htmlFor="organization"><FormattedMessage id="signup.owner.org.label" defaultMessage="Organization" /></label>
                                <input
                                    className={`form-control ${
                                        this.state.fields.organization.isValid() === false
                                            ? 'is-invalid'
                                            : ''
                                        }`}
                                    name="organization"
                                    onChange={this.handleInputChange}
                                    type="text"
                                    placeholder={this.props.intl.formatMessage(this.messages.org)}
                                    required
                                />
                                <div className="invalid-feedback">
                                    <FormattedMessage id="signup.owner.org.req" defaultMessage="Organization name is required." />
                                </div>
                            </div> */}
                            </div>
                            <fieldset>
                                <div className="form-row mt-md-5 mt-sm-3">
                                    <legend className="text-muted"><FormattedMessage id="signup.owner.addr.label" defaultMessage="Address" /></legend>
                                    <div className="col-md col-sm-12">
                                        <input
                                            value={this.state.fields.addressLine1.value || ''}
                                            className={`form-control ${
                                                this.state.fields.addressLine1.isValid() === false
                                                    ? 'is-invalid'
                                                    : ''
                                                }`}
                                            name="addressLine1"
                                            onChange={this.handleInputChange}
                                            type="text"
                                            placeholder={this.props.intl.formatMessage(this.messages.addrLine1)}
                                        />
                                        <div className="invalid-feedback">
                                            <FormattedMessage id="signup.owner.addr.req" defaultMessage="Address is required." />
                                        </div>
                                    </div>
                                    <div className="col-md col-sm-12">
                                        <input
                                            value={this.state.fields.addressLine2.value || ''}
                                            className={`form-control`}
                                            name="addressLine2"
                                            onChange={this.handleInputChange}
                                            type="text"
                                            placeholder={this.props.intl.formatMessage(this.messages.addrLine2)}
                                        />
                                    </div>
                                </div>
                                <div className="form-row mt-2">
                                    <div className="col-sm">
                                        <input
                                            value={this.state.fields.city.value || ''}
                                            className={`form-control ${
                                                this.state.fields.city.isValid() === false
                                                    ? 'is-invalid'
                                                    : ''
                                                }`}
                                            name="city"
                                            onChange={this.handleInputChange}
                                            type="text"
                                            placeholder={this.props.intl.formatMessage(this.messages.city)}
                                        />
                                        <div className="invalid-feedback">
                                            <FormattedMessage id="signup.owner.city.req" defaultMessage="City is required." />
                                        </div>
                                    </div>
                                    <div className="col-sm">
                                        <select
                                            value={this.state.fields.state.value || ''}
                                            className={`form-control custom-select ${
                                                this.state.fields.state.isValid() === false
                                                    ? 'is-invalid'
                                                    : ''
                                                }`}
                                            name="state"
                                            onChange={this.handleInputChange}
                                            placeholder={this.props.intl.formatMessage(this.messages.state)}
                                        >
                                            <option value="">{this.props.intl.formatMessage(this.messages.state)}</option>
                                            {
                                                states.map((state: { name: string, abbreviation: string }) =>
                                                    <option value={state.name} key={state.abbreviation}>{state.name}</option>
                                                )
                                            }
                                        </select>
                                        <div className="invalid-feedback">
                                            <FormattedMessage id="signup.owner.state.req" defaultMessage="State is required." />
                                        </div>
                                    </div>
                                    <div className="col-sm">
                                        <input
                                            className={`form-control ${
                                                this.state.fields.zip.isValid() === false
                                                    ? 'is-invalid'
                                                    : ''
                                                }`}
                                            name="zip"
                                            onChange={this.handleInputChange}
                                            type="number"
                                            placeholder={this.props.intl.formatMessage(this.messages.zip)}
                                            value={this.state.fields.zip.value || ''}
                                        />
                                        <div className="invalid-feedback">
                                            <FormattedMessage id="signup.owner.zip.req" defaultMessage="Zip code is required." />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <div className="form-row mt-md-5 mt-sm-3">
                                <div className="col-md col-sm-12">
                                    <label className="text-muted" htmlFor="phoneWork"><FormattedMessage id="signup.owner.phone.label" defaultMessage="Work Phone" /></label>
                                    <input
                                        autoComplete="off"
                                        className={`form-control ${
                                            this.state.fields.phoneWork.isValid() === false
                                                ? 'is-invalid'
                                                : ''
                                            }`}
                                        name="phoneWork"
                                        onChange={this.handleInputChange}
                                        type="text"
                                        placeholder={this.props.intl.formatMessage(this.messages.phoneFormat)}
                                        value={this.state.fields.phoneWork.value || ''}
                                    />
                                    <div className="invalid-feedback">
                                        <FormattedMessage id="signup.owner.phone.req" defaultMessage="A valid phone number is required." />
                                    </div>
                                </div>
                                <div className="col-md col-sm-12 py-2å">
                                    <label className="text-muted" htmlFor="phoneMobile"><FormattedMessage id="signup.owner.mobile.label" defaultMessage="Mobile" /></label>
                                    <input
                                        autoComplete="off"
                                        className={`form-control ${
                                            this.state.fields.phoneMobile.isValid() === false
                                                ? 'is-invalid'
                                                : ''
                                            }`}
                                        name="phoneMobile"
                                        onChange={this.handleInputChange}
                                        type="text"
                                        placeholder={this.props.intl.formatMessage(this.messages.phoneFormat)}
                                        value={this.state.fields.phoneMobile.value || ''}
                                    />
                                    <div className="invalid-feedback">
                                        <FormattedMessage id="signup.owner.phone.req" defaultMessage="A valid phone number is required." />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row mt-md-5 mt-sm-3">
                                <div className="col-lg-6 col-sm-12">
                                    <label className="text-muted" htmlFor="email"><FormattedMessage id="signup.owner.email.label" defaultMessage="Email" /></label>
                                    <input
                                        className={`form-control ${
                                            this.state.fields.email.isValid() === false
                                                ? 'is-invalid'
                                                : ''
                                            }`}
                                        name="email"
                                        onChange={this.handleInputChange}
                                        type="text"
                                        placeholder="mail@account.com"
                                        value={this.state.fields.email.value || ''}
                                    />
                                    <small className="text-muted"><FormattedMessage id="signup.owner.email.help" defaultMessage="Your email serves as your account's user name. Please be sure to use an email address you own and/or have access to." /></small>
                                    <div className="invalid-feedback">
                                        <FormattedMessage id="signup.owner.email.req" defaultMessage="Your email is required." />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-md-5 mt-sm-3">
                        <div className="page-title col">
                            <h3 className="harmonize"><FormattedMessage id="signup.owner.pwd.hdr" defaultMessage="Account Password" /></h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-9">
                            <div className="form-row">
                                <div className="col-md-6">
                                    <label className="text-muted" htmlFor="password"><FormattedMessage id="signup.owner.pwd.label" defaultMessage="Enter Password" /></label>
                                    <input
                                        className={`form-control ${
                                            this.state.fields.password.isValid() === false
                                                ? 'is-invalid'
                                                : ''
                                            }`}
                                        name="password"
                                        value={this.state.fields.password.value || ''}
                                        onChange={this.handleInputChange}
                                        type="password"
                                        placeholder="***********"
                                    />
                                    <p className="text-muted">
                                        <small>
                                            <FormattedMessage id="signup.owner.pwd.valid" defaultMessage="Passwords must be at least 8 characters in length" />
                                        </small>
                                    </p>
                                    <div className="invalid-feedback">
                                        <FormattedMessage id="signup.owner.pwd.req" defaultMessage="A valid password is required." />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row mt-md-4 mt-sm-3">
                                <div className="col-md-6">
                                    <label className="text-muted" htmlFor="passwordConfirmed"><FormattedMessage id="signup.owner.pwd.confirm" defaultMessage="Confirm Password" /></label>
                                    <input
                                        className={`form-control ${
                                            this.state.fields.passwordConfirmed.isValid() === false
                                                ? 'is-invalid'
                                                : ''
                                            }`}
                                        name="passwordConfirmed"
                                        value={this.state.fields.passwordConfirmed.value || ''}
                                        onChange={this.handleInputChange}
                                        type="password"
                                        placeholder="***********"
                                    />
                                    <div className="invalid-feedback">
                                        <FormattedMessage id="signup.owner.pwd.match" defaultMessage="Your passwords must match." />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row border-top mt-4 terms-check">
                        <label className="text-muted">
                            <input
                                value={`${this.state.fields.termsAccepted.value}` || 'false'}
                                className={`${
                                    this.state.fields.termsAccepted.isValid() === false
                                        ? 'is-invalid'
                                        : ''
                                    }`}
                                type="checkbox"
                                checked={this.state.fields.termsAccepted.value || false}
                                name="termsAccepted"
                                onChange={this.handleInputChange} />
                            <FormattedHTMLMessage id="signup.terms.check.label"
                                values={{ link: `${SITE_URL}${TERMS_PATH}` }}
                                defaultMessage='By checking this box, you acknowledge that you have read and agree to the Harmonize®&trade; <a href="{link}" target="_blank">Terms of Use</a>.' />
                            <span className="invalid-feedback">
                                <FormattedMessage id="signup.terms.check.invalid" defaultMessage="You must accept the terms of use." />
                            </span>
                        </label>
                    </div>
                    <div className="row mt-4 buttons">
                        <button className="primary" onClick={this.handleSave}>
                            <FormattedMessage id="button.continue" defaultMessage="Continue" />
                        </button>
                        <Link to="/" className="btn btn-link">
                            <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
                        </Link>
                    </div>
                </div>
            </section>
        );
    }
}
export default injectIntl<IProps>(CreateAccount);


// WEBPACK FOOTER //
// ./src/client/create/Account.tsx